import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initGA, trackPageView, markInternalTraffic } from "../lib/analytics";
import { useAuth } from "../contexts/AuthContext";

// Mount once inside <BrowserRouter>. Initializes GA on first render and
// fires a page_view event on every route change.
export default function AnalyticsTracker() {
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    initGA();
  }, []);

  useEffect(() => {
    if (user?.role === "admin") markInternalTraffic();
  }, [user?.role]);

  useEffect(() => {
    // Defer one tick so document.title (set by pages) is current.
    const t = setTimeout(() => {
      trackPageView(location.pathname + location.search);
    }, 0);
    return () => clearTimeout(t);
  }, [location.pathname, location.search]);

  return null;
}
